// theme.js
export const lightTheme = {
  mode: "light",

  background: "#ffffff",
  text: "#000000",
  primary: "#1976d2",
  secondary: "#f50057",
  success: "#4caf50",
  warning: "#ff9800",
  gradient: "linear-gradient(135deg, #f0f4ff 0%, #cfe0ff 100%)",
};

export const darkTheme = {
  mode: "dark",

  background: "#1e243c",
  text: "#ffffff",
  primary: "#2196f3",
  secondary: "#ff4081",
  success: "#81c784",
  warning: "#ffb74d",
  gradient: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
};
